/** @format */

import {Box, Button, Dialog, DialogContent, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({theme}) => ({
  '& .MuiDialog-paper': {
    maxWidth: 914,
    borderRadius: theme.spacing(8),
    overflow: 'hidden',
    background: `
      linear-gradient(131.8deg, rgba(57, 186, 164, 0) 8.96%, rgba(57, 186, 164, 0.75) 121.07%),
      radial-gradient(100% 100% at 50% 100%, rgba(88, 172, 242, 0.06) 0%, rgba(88, 172, 242, 0.6) 100%),
      ${theme.palette.semantic_light?.surface.background}
    `,
  },
}));

export const StyledDialogContent = styled(DialogContent)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  padding: theme.spacing(8),
}));

export const HeaderTitle = styled(Typography)(({theme}) => ({
  fontSize: 32,
  lineHeight: 'normal',
  color: theme.palette.semantic_light?.primary.onContainer,
}));

export const Subtitle = styled(Typography)(({theme}) => ({
  fontSize: 16,
  lineHeight: '20px',
  color: theme.palette.semantic_light?.primary.onContainer,
}));

export const CardsRow = styled(Box)(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(4),
}));

export const FeatureCard = styled(Box)(({theme}) => ({
  width: 417,
  padding: theme.spacing(4, 4, 8, 4),
  border: `1px solid ${theme.palette.semantic_light?.primary.container}`,
  borderRadius: theme.spacing(6),
  background: 'rgba(250, 251, 254, 0.2)',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const TabsRow = styled(Box)(({theme}) => ({
  display: 'flex',
  alignSelf: 'flex-start',
  gap: '1px',
  '& > *:first-of-type': {
    borderTopLeftRadius: theme.spacing(2),
  },
  '& > *:last-of-type': {
    borderTopRightRadius: theme.spacing(2),
  },
}));

export const TabActive = styled(Box)(({theme}) => ({
  flexShrink: 0,
  padding: theme.spacing(3),
  background: theme.palette.semantic_light?.primary.main,
  color: theme.palette.semantic_light?.primary.on,
  fontSize: 16,
  lineHeight: '20px',
  whiteSpace: 'nowrap',
}));

export const TabInactive = styled(Box)(({theme}) => ({
  flexShrink: 0,
  padding: theme.spacing(3),
  background: theme.palette.semantic_light?.surface.surface1,
  color: theme.palette.semantic_light?.surface.onSurfaceLight,
  opacity: 0.5,
  fontSize: 16,
  lineHeight: '20px',
  whiteSpace: 'nowrap',
}));

export const StepsList = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 16, 0, 2),
}));

export const Step = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
}));

export const CounterIcon = styled('span')(({theme}) => ({
  '&.material-symbols-outlined': {
    fontSize: 20,
  },
  color: theme.palette.semantic_light?.primary.main,
  lineHeight: 1,
}));

export const StepText = styled(Typography)(({theme}) => ({
  flex: '1 0 0',
  fontSize: 16,
  lineHeight: '20px',
  color: theme.palette.semantic_light?.primary.onContainer,
}));

export const FallbackBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 16, 0, 2),
  alignItems: 'flex-start',
}));

export const FallbackTextColumn = styled(Box)({
  display: 'flex',
  flex: '1 0 0',
  flexDirection: 'column',
  minWidth: 0,
});

export const FallbackText = styled(Typography)(({theme}) => ({
  fontSize: 16,
  lineHeight: '20px',
  color: theme.palette.semantic_light?.primary.onContainer,
}));

export const FallbackEmphasis = styled(Typography)(({theme}) => ({
  fontSize: 24,
  lineHeight: '28px',
  color: theme.palette.semantic_light?.primary.onContainer,
}));

export const PlansCard = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  border: `1px solid ${theme.palette.semantic_light?.primary.container}`,
  borderRadius: theme.spacing(4),
}));

export const MovingIcon = styled('span')(({theme}) => ({
  '&.material-symbols-outlined': {
    fontSize: 32,
  },
  color: theme.palette.semantic_light?.primary.main,
  transform: 'rotate(-10deg)',
  lineHeight: 1,
  flexShrink: 0,
}));

export const PlansContent = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  flex: '1 0 0',
}));

export const PlansTitle = styled(Typography)(({theme}) => ({
  fontSize: 18,
  lineHeight: '22px',
  color: theme.palette.semantic_light?.primary.onContainer,
}));

export const PlansLine = styled(Typography)(({theme}) => ({
  fontSize: 14,
  lineHeight: '16px',
  color: theme.palette.semantic_light?.primary.onContainer,
}));

export const ActionButton = styled(Button)(({theme}) => ({
  alignSelf: 'flex-start',
  padding: theme.spacing(3.5, 16),
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.semantic_light?.good.main,
  color: theme.palette.semantic_light?.good.on,
  fontSize: 16,
  lineHeight: '20px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.semantic_light?.good.hover,
  },
}));
